import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Offline } from 'react-detect-offline'

import Sidebar from './Sidebar'
import Navbar from './Navbar'
import TopNavbar from './TopNavbar'

export class Layout extends Component {
  static propTypes = {
    isSidebar: PropTypes.bool,
    children: PropTypes.node,
    checkboxLabel: PropTypes.string,
    onCheckboxChange: PropTypes.func,
    handleSwitch: PropTypes.func,
    isSwitchChecked: PropTypes.bool,
    pendingDevicesNumber: PropTypes.string,
  }

  state = {
    isSidebarActive: false,
  }

  toggleSidebarActive = () => {
    this.state.isSidebarActive
      ? document.body.classList.remove('sidebar-open')
      : document.body.classList.add('sidebar-open')
    this.setState((state) => ({ isSidebarActive: !state.isSidebarActive }))
  }

  render() {
    const { isSidebarActive } = this.state
    const {
      isSidebar,
      children,
      checkboxLabel,
      onCheckboxChange,
      handleSwitch,
      isSwitchChecked,
      pendingDevicesNumber,
    } = this.props

    return (
      <>
        <Offline>
          <div className="offline">You are currently offline. Check your connection.</div>
        </Offline>
        <TopNavbar toggleSidebarActive={this.toggleSidebarActive} />
        <Navbar
          checkboxLabel={checkboxLabel}
          handleSwitch={handleSwitch}
          isSwitchChecked={isSwitchChecked}
          onCheckboxChange={onCheckboxChange}
          pendingDevicesNumber={pendingDevicesNumber}
        />
        {isSidebar && (
          <Sidebar
            isOpen={isSidebarActive}
            title={'Device Manager'}
            toggleSidebarActive={this.toggleSidebarActive}
          />
        )}
        <main className="layout">{children}</main>
      </>
    )
  }
}

export default Layout
